module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNSAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxyZWN0IHdpZHRoPSIyNSIgaGVpZ2h0PSIyNSIgcng9IjUiIGZpbGw9ImJsYWNrIi8+DQo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMgMTNMNS4zMzMzMyAxMC42NjY3TDEwIDE1LjMzMzNMMTkuMzMzMyA2TDIxLjY2NjcgOC4zMzMzM0wxMCAyMEwzIDEzWiIgZmlsbD0iI0Y2RDlBQSIvPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/withdrawSetup/choose1.svg
// module id = rRMe
// module chunks = 0